if (!customElements.get('predictive-search')) {
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input[type="search"]');
      this.resultsContainer = this.querySelector(
        '.js-results-container'
      );
      this.btnSubmit = this.querySelector('.js-btn-submit');
      this.btnClearText = this.querySelector('.js-btn-clear-text');
      this.errorMessageContainer = this.querySelector(
        '.js-message-error'
      );
      this.errorMessageText =
        this.errorMessageContainer.querySelector('[data-text]');
      this.timeout = null;
      this.isOpen = false;
      this.drawer = this.closest('.js-drawer');

      var searchDrawerContent = document.querySelector('.drawer__content--search');
      var searchSuggestions = document.querySelector('.search-drawer__suggestions');

      this.input.addEventListener('input', e => {
        clearTimeout(this.timeout);

        this.timeout = setTimeout(() => {
          const searchTerm = this.input.value.trim();

          if (searchTerm.length <= 0) {
            this.close();
            if(window.innerWidth < 990) {
              searchDrawerContent.style.height = 'auto';
            }
            if(searchSuggestions) {
              searchSuggestions.style.display = 'block';
            }
            return;
          }

          this.isOpen = true;
          this.getSearchResults(searchTerm);
          if(window.innerWidth <= 990) {
            searchDrawerContent.style.height = '100%';
          }
          if(searchSuggestions) {
            searchSuggestions.style.display = 'none';
          }
        }, 300);
      });

      this.input.addEventListener('keydown', e => {
        const isEscape = e.key === 'Escape';

        if (!isEscape) {
          return;
        }

        if (!this.input.value) {
          if (this.drawer) {
            this.drawer.parentElement.parentElement.toggleDrawer();
          }

          return;
        }

        this.close();
      });

      this.btnClearText.addEventListener('click', e => {
        this.close();
        searchDrawerContent.style.height = 'auto';
        if(searchSuggestions) {
          searchSuggestions.style.display = 'block';
        }
      });
    }

    async getSearchResults(searchTerm) {
      try {
        const response = await fetch(
          `${Shopify.routes.root}search/suggest?q=${searchTerm}&resources[type]=product&resources[limit]=8&section_id=predictive-search`
        );

        if (!this.isOpen) {
          return;
        }

        if (!response.ok) {
          const error = new Error(response.status);

          throw error;
        }

        const text = await response.text();
        const resultsMarkup = new DOMParser()
          .parseFromString(text, 'text/html')
          .querySelector(
            '#shopify-section-predictive-search'
          ).innerHTML;

        this.resultsContainer.innerHTML = resultsMarkup;
        this.open();


        // Clean search tracking parameters from product links New added
        this.cleanSearchTrackingParams();

        // new added product cards - quick cart triggers - set event listeners
        document.querySelector('quick-cart-drawer')?.initTriggers();

      } catch (error) {
        this.errorMessageText.textContent = error.message;
        this.errorMessageContainer.classList.remove('hidden');
      }
    }

    open() {
      this.classList.add('is-open');
      this.resultsContainer.classList.remove('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.btnSubmit.setAttribute('tabindex', '-1');
      this.btnClearText.removeAttribute('disabled');
    }

    close() {
      this.isOpen = false;
      this.classList.remove('is-open');
      this.resultsContainer.classList.add('hidden');
      this.errorMessageContainer.classList.add('hidden');
      this.input.value = '';
      this.input.focus();
      this.btnSubmit.removeAttribute('tabindex');
      this.btnClearText.setAttribute('disabled', true);
    }

    // Clean search tracking parameters from product links New added
    cleanSearchTrackingParams() {
      // Function to remove Shopify search tracking parameters
      const removeTrackingParams = (url) => {
        if (!url) return url;

        try {
          const urlObj = new URL(url, window.location.origin);
          // Remove tracking parameters: _pos, _psq, _ss, _v, variant
          urlObj.searchParams.delete('_pos');
          urlObj.searchParams.delete('_psq');
          urlObj.searchParams.delete('_ss');
          urlObj.searchParams.delete('_v');
          urlObj.searchParams.delete('variant');

          // Return cleaned URL (relative path)
          return urlObj.pathname + (urlObj.search ? urlObj.search : '');
        } catch (e) {
          // If URL parsing fails, try simple string replacement
          return url
            .replace(/[?&]_pos=[^&]*/g, '')
            .replace(/[?&]_psq=[^&]*/g, '')
            .replace(/[?&]_ss=[^&]*/g, '')
            .replace(/[?&]_v=[^&]*/g, '')
            .replace(/[?&]variant=[^&]*/g, '')
            .replace(/[?&]$/, '');
        }
      };

      // Clean all product links in the results container
      const productLinks = this.resultsContainer.querySelectorAll('[data-product-link]');
      productLinks.forEach(link => {
        const originalHref = link.getAttribute('href');
        if (originalHref) {
          const cleanedHref = removeTrackingParams(originalHref);
          link.setAttribute('href', cleanedHref);
        }
      });

      // Add click event listener to intercept navigation and clean URL
      productLinks.forEach(link => {
        link.addEventListener('click', (e) => {
          const href = link.getAttribute('href');
          if (href) {
            const cleanedHref = removeTrackingParams(href);
            if (cleanedHref !== href) {
              link.setAttribute('href', cleanedHref);
            }
          }
        });
      });
    }
  }

  customElements.define('predictive-search', PredictiveSearch);
}
